function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useLayoutEffect, useRef, useState, memo } from 'react';
import facade from '../../common/utils/facade';
import Loader from '../Loader';
import './index.scss';
const Image = /*#__PURE__*/memo(({
  src,
  transparent,
  facadeStyle,
  fallbackSrc,
  fallbackNode,
  loaderProps,
  ...props
}) => {
  const [{
    show,
    loaderror
  }, setStates] = useState({
    show: false,
    loaderror: false
  });
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (show) {
      const clean = setTimeout(() => ref.current?.parentElement?.classList.remove('image-parent'), 150);
      return () => clearTimeout(clean);
    } else {
      ref.current?.parentElement?.classList.add('image-parent');
    }
  }, [show]);

  const handleLoad = () => {
    setStates(prev => ({ ...prev,
      show: true
    }));
  };

  const handleLoadError = () => {
    setStates(prev => ({ ...prev,
      show: true,
      loaderror: true
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, loaderror ? fallbackNode || /*#__PURE__*/React.createElement("img", _extends({}, props, {
    src: fallbackSrc || "error"
  })) : /*#__PURE__*/React.createElement("img", _extends({
    ref: ref
  }, props, {
    src: src,
    onLoad: handleLoad,
    onError: handleLoadError,
    style: show ? props.style : {
      'display': 'none'
    }
  })), !show && /*#__PURE__*/React.createElement("img", _extends({}, props, {
    style: { ...props.style,
      ...facadeStyle
    },
    "data-facade": "true",
    src: facade
  })), /*#__PURE__*/React.createElement(Loader, _extends({}, loaderProps, {
    active: !show,
    style: {
      zIndex: 0,
      ...loaderProps?.style
    },
    transparent: transparent
  })));
});
export default Image;